export class ApplicationFilePreview {
    fileName: string;
    base64FilePreview: string;
}